import { AuthGuard } from '../_guards/auth.guard';
import { Routes } from '@angular/router';
import { ReportsCenterComponent } from './reports-center.component';

export const ReportsCenterRoutes: Routes = [
    { canActivate: [AuthGuard], path: 'reportscenter', component: ReportsCenterComponent, data: {  roles: "ReportsCenter",  title: 'מרכז דוחו"ת' } },

];
